// Importance and priority dropdown options, display labels and CSS classes

export const IMPORTANCE_OPTIONS = [
    { label: '—', value: 0 },
    { label: 'High', value: 900 },
    { label: 'Medium', value: 500 },
    { label: 'Low', value: 100 },
];

// Numeric importanceId/prioId → display label
export const getImportanceLabel = (val) => {
    if (val === 900) return 'High';
    if (val === 500) return 'Medium';
    if (val === 100) return 'Low';
    return '—';
};

// Numeric importanceId/prioId → CSS class
export const getImportanceClass = (val) => {
    if (val === 900) return 'j-val-high';
    if (val === 500) return 'j-val-medium';
    if (val === 100) return 'j-val-low';
    return null;
};
